<template>
  <div class="inline-flex items-center m-2.5">
    <span
      class="
        inline-flex
        justify-center
        items-center
        prose-sm
        font-bold
        w-10.5
        h-10.5
        mr-2.5
        border-2 border-vice-teal-400
        rounded-full
      "
    >
      <CheckIcon class="w-5 h-5 text-vice-teal-400" />
    </span>
    <div class="flex flex-col">
      <span class="text-sm font-medium leading-5">{{ phaseData.title }}</span>
      <span class="text-sm font-medium leading-5">{{ formatedDuration }}</span>
    </div>
  </div>
</template>

<script>
import { CheckIcon } from '@heroicons/vue/solid';

// TODO: Move imports to timeFormatter composable
import { computed } from 'vue';
import dayjs from 'dayjs';
import duration from 'dayjs/plugin/duration';

dayjs.extend(duration);

export default {
  props: {
    phaseData: {
      type: Object,
      required: true,
    },
  },
  components: {
    CheckIcon,
  },
  setup(props) {
    // TODO: Move method to timeFormatter composable and fix issue where checking prop type is neccessary
    const formatedDuration = computed(() =>
      dayjs.duration(props.phaseData.duration).format('H:mm:ss'),
    );

    return {
      formatedDuration,
    };
  },
};
</script>
